import React from 'react';
import classNames from 'classnames';

import ProfileImage, {
  IMAGE_SIZES
} from '@buyside/components/presentation/ProfileImage/profileImage';
import Skeleton, {
  SKELETON_SIZES,
  SKELETON_WIDTHS
} from '@buyside/components/presentation/Skeleton/skeleton';

import { defaultUserImageUrl } from '@buyside/util/urlHelper';

import commentHeaderStyles from '@buyside/components/presentation/Comment/CommentHeader/commentHeaderStyles.scss';
import styles from './showPageCommentStyles.scss';

const ShowPageCommentLoading: React.FC = () => (
  <div className={styles.commentContainer}>
    <div className={styles.comment}>
      <div className={commentHeaderStyles.commentHeader}>
        <div className={commentHeaderStyles.profileImage}>
          <ProfileImage source={defaultUserImageUrl()} size={IMAGE_SIZES.SMALL} />
        </div>
        <div className={classNames(commentHeaderStyles.userDisplay)}>
          <div className={commentHeaderStyles.userName}>
            <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.SMALL} />
          </div>
          <div className={commentHeaderStyles.employerRow}>
            <Skeleton size={SKELETON_SIZES.SMALL} width={SKELETON_WIDTHS.MEDIUM} />
          </div>
        </div>
      </div>
      <div className={styles.commentBody}>
        <Skeleton width={SKELETON_WIDTHS.FULL} />
        <Skeleton width={SKELETON_WIDTHS.FULL} />
        <Skeleton width={SKELETON_WIDTHS.TWO_THIRD} />
      </div>
    </div>
  </div>
);

export default ShowPageCommentLoading;
